<template>
  <div
    class="the-navbar__user-meta items-right"
    style="position:absolute; right:20px; top:12px;"
    v-if="activeUserInfo.displayName"
  >
    <div class="text-right leading-tight hidden sm:block">
      <!--
      <div class="font-semibold">{{ activeUserInfo.displayName }}</div>
      <small>Available</small>
      -->
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <v-gravatar
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
        <!--
        <b-avatar size="lg" variant="light-success" text="PI" />
        -->
        <!--
        <img
          v-if="activeUserInfo.photoURL"
          key="onlineImg"
          :src="activeUserInfo.photoURL"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
        -->
      </div>
      <vs-dropdown-menu class="vx-navbar-dropdown" style="padding-top:10px;">
        <ul style="min-width: 12rem;">
          <li
            @click="goTo('/settings/profile')"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ activeUserInfo.displayName }}</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="merchantDialog = true"
          >
            <feather-icon icon="HomeIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Switch Merchant</span>
          </li>
          <!--

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2"></span>
          </li>
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Inbox</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tasks</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li>

          -->
          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>

    <merchant-dialog
      :showDialog="merchantDialog"
      @close="merchantDialog = false"
      @submit="onMerchantSubmit"
    ></merchant-dialog>

    <event-dialog
      :showDialog="eventDialog"
      :merchant="s"
      @close="eventDialog = false"
      @submit="onEventSubmit"
    ></event-dialog>
  </div>
</template>

<script>
import { BAvatar } from "bootstrap-vue";
import MerchantDialog from "@/components/soldoutt/MerchantDialog.vue";
import EventDialog from "@/components/soldoutt/EventDialog.vue";

export default {
  components: {
    BAvatar,
    MerchantDialog,
    EventDialog
  },
  data() {
    return {
      merchantDialog: false,
      eventDialog: false,
      s: null
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    }
  },
  created() {
    //console.log(this.activeUserInfo);
  },
  methods: {
    goTo(link) {
      this.$router.push({ path: link });
    },
    onMerchantSubmit(data) {
      this.s = data.s;
      this.merchantDialog = false;
      this.eventDialog = true;
    },
    onEventSubmit(data) {},
    logout() {
      this.$store.dispatch("Auth/logout").then(() => {
        this.$store.dispatch("Utility/logout").then(() => {
          this.$store.dispatch("Event/logout").then(() => {
            this.$router.push("/login").catch(() => {});
          });
        });
      });
    }
  }
};
</script>
